import { Link } from "react-router-dom";
import { assetUrl } from "@/lib/api";
import { Leaf } from "lucide-react";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to={`/products/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
        {product.image_url ? (
          <img
            src={assetUrl(product.image_url)}
            alt={product.name}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-primary/30">
            <Leaf className="h-12 w-12" />
          </div>
        )}
        {product.category && (
          <span className="absolute left-3 top-3 rounded-full bg-white/90 px-3 py-1 text-xs font-medium text-primary backdrop-blur">
            {product.category}
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-serif text-lg font-600 text-foreground">{product.name}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground line-clamp-3">
          {product.description}
        </p>
        <div className="mt-4 flex items-center justify-between">
          {product.price ? (
            <div className="text-base font-700 text-[var(--brand-navy)]">{product.price}</div>
          ) : <span />}
          <span className="text-xs font-semibold text-primary opacity-0 transition-opacity group-hover:opacity-100">View details →</span>
        </div>
      </div>
    </Link>
  );
}
